import React from 'react';
import DiceScene from './DiceScene';
import NoSupport from './NoSupport';
import './App.css';

const App = () => {
  const isMobile = navigator.userAgent.includes('Mobile');

  return isMobile ? <DiceScene /> : <NoSupport />;
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js